import React from "react";
import { BiCheckbox, BiSolidCheckboxChecked } from "react-icons/bi";
import styles from "./hide-section.module.css";

/**
 * HideItem Component
 * 
 * Toggleable checkbox item for showing/hiding individual datatable columns.
 * Displays field name with checkbox icon showing current visibility state.
 * Updates parent array when clicked.
 * 
 * @param {Object} props - Component props
 * @param {Object} props.props - Parent props containing hiddenFieldNames array
 * @param {Object} props.field - Field object with actualName and displayName
 * @param {Function} props.remove - Callback to hide field (add to hidden)
 * @param {Function} props.push - Callback to show field (remove from hidden)
 * @returns {JSX.Element} Clickable field visibility toggle item
 */
const HideItem = ({ props, field, remove, push }) => {
  const { hiddenFieldNames } = props;

  return (
    <div
      className={styles.itemselectiondiv}
      onClick={
        hiddenFieldNames.includes(field.actualName)
          ? () => remove(field.actualName)
          : () => push(field.actualName)
      }
    >
      {hiddenFieldNames.includes(field.actualName) ? (
        <BiCheckbox size={"1.5rem"} color="#d1d5db" />
      ) : (
        <BiSolidCheckboxChecked size={"1.5rem"} color="#16a34a" />
      )}
      <span>{field.displayName}</span>
    </div>
  );
};

export default HideItem;
